import { Injectable } from '@angular/core';
import imageCompression, { Options } from 'browser-image-compression';

@Injectable({
  providedIn: 'root',
})
export class ImageCompressionService {
  private static readonly _defaultOptions: Options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1280,
    useWebWorker: true,
    initialQuality: 0.8,
    fileType: 'image/webp',
  };

  async compressImage(file: File, imageSize: number): Promise<File> {
    if (!file.type.startsWith('image/')) {
      return file;
    }

    return imageCompression(file, {
      ...ImageCompressionService._defaultOptions,
      maxWidthOrHeight: imageSize,
    });
  }
}
